import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface UpdateTrailStudentStatusByIdParams {
  studentId: string;
  enrollmentStatus:
    | 'Trial Scheduled'
    | 'Trial Completed'
    | 'Trial Missed'
    | 'Enrolled'
    | 'Not Enrolled';
}
export const updateTrialStudentStatusById = async ({
  studentId,
  enrollmentStatus,
}: UpdateTrailStudentStatusByIdParams) => {
  const response = await baseAPI.patch<unknown>(
    `trialstudents/${studentId}/status`,
    {
      status: enrollmentStatus,
    },
  );
  return response.data;
};

export const useUpdateTrialStudentStatusById = () => {
  return useMutation({
    mutationFn: (params: UpdateTrailStudentStatusByIdParams) =>
      updateTrialStudentStatusById(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRIAL_STUDENTS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRIAL_CONVERSION],
      });
    },
  });
};
